import React, { useEffect } from 'react'
import styled from 'styled-components'

interface DialogProps {
  $isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

const DialogOverlay = styled.div<{ $isOpen: boolean }>`
  display: flex;
  position: fixed;
  min-width: 100vw;
  min-height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  justify-content: center;
  align-items: center;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  font-weight: normal;
  transition:
    opacity 0.55s ease-in-out,
    visibility 0.55s ease-in-out;
`

const DialogBox = styled.div<{ $isOpen: boolean }>`
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '100vh')});
  transition: transform 0.55s ease-in-out;
`

const CloseButton = styled.button`
  border: none;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
`

export const Dialog = ({ $isOpen, onClose, children }: DialogProps) => {
  useEffect(() => {
    if ($isOpen) {
      document.body.style.overflow = 'hidden' // 스크롤 비활성화
    } else {
      document.body.style.overflow = 'auto' // 스크롤 활성화
    }

    // cleanup으로 컴포넌트가 언마운트되거나 다이얼로그가 닫힐 때 스크롤을 복원
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [$isOpen])

  return (
    <DialogOverlay $isOpen={$isOpen}>
      <DialogBox $isOpen={$isOpen}>
        {/* <CloseButton onClick={onClose}>X</CloseButton> */}
        {children}
      </DialogBox>
    </DialogOverlay>
  )
}
